import Vue from "vue";

/**
 * Clear state function
 * @param {Object} state
 */
function clearSpecific(state) {
  state.firstName = "";
  state.lastName = "";
  state.pha_line1 = "";
  state.pha_line2 = "";
  state.pha_city = "";
  state.pha_state = 0;
  state.pha_postalCode = "";
  state.notes = "";
  state.birthDate = {
    dayOfMonth: 0,
    month: 0,
    year: 0
  };
  state.phone = [];
  state.email = [];
  state.phoneType = [0, 0, 0, 0];
  state.submitted = false;
  state.selectedInsuranceValue = 0;
  state.insuranceType = "primary";
  state.insuranceId = "";
}

/**
 * Mutations for add new
 */
export const mutations = {
  /**
   * Setting first name
   * @param {Object} state
   * @param {String} name
   */
  setFirstName(state, name) {
    state.firstName = name.trim();
  },
  /**
   * Setting last name
   * @param {Object} state
   * @param {String} name
   */
  setLastName(state, name) {
    state.lastName = name.trim();
  },
  /**
   *
   * @param {Object} state
   * @param {String} name
   */
  setPhaLine1(state, name) {
    state.pha_line1 = name.trim();
  },
  /**
   *
   * @param {Object} state
   * @param {String} name
   */
  setPhaLine2(state, name) {
    state.pha_line2 = name.trim();
  },
  /**
   *
   * @param {Object} state
   * @param {String} name
   */
  setPhaCity(state, name) {
    state.pha_city = name.trim();
  },
  /**
   *
   * @param {Object} state
   * @param {Number} code
   */
  setPhaState(state, code) {
    state.pha_state = code;
  },
  /**
   *
   * @param {Object} state
   * @param {String} name
   */
  setPhaPostalCode(state, name) {
    state.pha_postalCode = name.trim();
  },
  /**
   * Set email
   * @param {Object} state
   * @param {Object} param1
   */
  setEmail(state, { value, index }) {
    const newEmails = [...state.email];
    newEmails[index] = value;
    state.email = newEmails;
  },
  /**
   * Remove an email from the list of emails
   * @param {Object} state
   * @param {Number} index
   */
  removeEmail(state, index) {
    const newEmails = [...state.email];
    newEmails.splice(index, 1);
    state.email = newEmails;
  },
  /**
   * Set phone
   * @param {Object} state
   * @param {Object} param1
   */
  setPhone(state, { value, index }) {
    const newPhones = [...state.phone];
    newPhones[index] = value;
    state.phone = newPhones;
  },
  /**
   * Remove a phone and phone type from the list
   * @param {Object} state
   * @param {Number} index
   */
  removePhone(state, index) {
    const newPhones = [...state.phone];
    newPhones.splice(index, 1);
    state.phone = newPhones;
    const newPhoneType = [...state.phoneType];
    newPhoneType.splice(index, 1);
    newPhoneType.push(0);
    state.phoneType = newPhoneType;
  },
  /**
   * Set phone type
   * @param {Object} state
   * @param {Object} param1
   */
  setPhoneType(state, { value, index }) {
    const newPhoneType = [...state.phoneType];
    newPhoneType[index] = value;
    state.phoneType = newPhoneType;
  },
  /**
   * Setting the date of birth
   * @param {Object} state
   * @param {Object} date
   */
  setBirthDate(state, date) {
    state.birthDate = date;
  },
  /**
   * Start loading
   * @param {Object} state
   */
  startLoading(state) {
    state.loading = state.loading + 1;
  },
  /**
   * Stop loading
   * @param {Object} state
   */
  stopLoading(state) {
    state.loading = state.loading - 1;
  },
  /**
   * Setting the insurance companies
   * @param {Object} state
   * @param {Object} param1
   */
  setInsuranceCompanies(state, { id, companies }) {
    Vue.set(state.insuranceCompanies, id, companies);
  },
  /**
   * Setting the selected value
   * @param {Object} state
   * @param {Number} value
   */
  setSelectedInsuranceValue(state, value) {
    if (!isNaN(value)) {
      state.selectedInsuranceValue = parseInt(value);
    }
  },
  /**
   * Setting the insurance type
   * @param {Object} state
   * @param {String} value
   */
  setInsuranceType(state, value) {
    state.insuranceType = value;
  },
  /**
   * Setting the insurance id
   * @param {Object} state
   * @param {String} value
   */
  setInsuranceId(state, value) {
    state.insuranceId = value;
  },
  /**
   * Setting the timezone options
   * @param {Object} state
   * @param {Array} timezones
   */
  setTimezoneOptions(state, timezones) {
    if (timezones) {
      Vue.set(state.timezone, "list", timezones);
      Vue.set(state.timezone, "selected", "America/New_York");
    }
  },
  /**
   * Set the state codes
   * @param {Object} state
   * @param {Array} stateCodes
   */
  setStateCodes(state, stateCodes) {
    if (stateCodes) {
      state.stateCodes = stateCodes;
    }
  },
  /**
   * Change the selected timezone
   * @param {Object} state
   * @param {String} value
   */
  setSelectedTimezone(state, value) {
    Vue.set(state.timezone, "selected", value);
  },
  /**
   * Set weather form has been submitted
   * @param {Object} state
   * @param {Boolean} value
   */
  setFormSubmitted(state, value) {
    state.submitted = value;
  },
  /**
   * Set the notes
   * @param {Object} state
   * @param {String} value
   */
  setNotes(state, value) {
    state.notes = value.trim();
  },
  /**
   * Clear only the selected value so that no one is able to add the wrong insurance company
   * @param {Object} state
   */
  clearInsuranceDetails(state) {
    state.selectedInsuranceValue = 0;
  },
  /**
   * Clear the state
   * @param {Object} state
   */
  clear(state) {
    clearSpecific(state);
  },
  /**
   * Clear the state for logout
   * @param {Object} state
   */
  clearAll(state) {
    clearSpecific(state);
    state.insuranceCompanies = {};
  },
  /**
   * Set some basic values for edit
   * @param {Object} state
   * @param {Object} param1
   */
  setEdit(
    state,
    {
      firstName,
      lastName,
      birthDate,
      phone,
      phoneType,
      email,
      timezone,
      pha_line1,
      pha_line2,
      pha_city,
      pha_state,
      pha_postalCode,
      notes
    }
  ) {
    state.firstName = firstName;
    state.lastName = lastName;
    state.birthDate = birthDate;
    state.phone = phone;
    state.phoneType = phoneType;
    state.email = email;
    state.pha_line1 = pha_line1;
    state.pha_line2 = pha_line2;
    state.pha_city = pha_city;
    state.pha_state = pha_state;
    state.pha_postalCode = pha_postalCode;
    state.notes = notes;
    Vue.set(state.timezone, "selected", timezone);
  }
};
